import "../../../CardProfile/CardProfile.scss";
import money from "../../../../../image/Company/wallet-with-card-sticking-out.png";
import deliver from "../../../../../image/Company/fast-delivery.png";
import time from "../../../../../image/Company/timer.png";
import verified from "../../../../../image/Company/shield.png";
import Header from "../../../../Header/Header";
import Footer from "../../../../Footer/Footer";
import logo1 from "../../../../../image/logotype/logo_corn.svg";
import goodsPage from "../../../../../image/goods.image/corn/qbyHGQcOhx.png";
import Description from '../TermoCard/TermoDesc';
import Reference from '../TermoCard/TermoRef';
import Button from "../../../../../assets/Button/ButtonBuy/ButtonBuy"
import crumbs from "../../../../../icons/icons8-home.svg";
import forward_arrow from "../../../../../icons/icons-forward-arrow.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function Item() {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <>
      <Header />
      <Helmet>
        <meta name="keywords" content="Гібрид, кукурудза, Гібрид кукурудзи, Термо, купити, Санберрі Україна, насіння" />
        <title>Насіння кукурудзи НК Термо (NK Termo) • Купити оптом і в роздріб | Sunberry Ukraine</title>
        <link rel="canonical" href="https://sun-ukr.com/termo" />
        <meta name="description" content="🌽Насіння кукурудзи НК Термо (NK Termo) оптом і в роздріб ⭐ Від якісного виробника Syngenta ✅ Замовляйте за телефоном ☎️ +38(068)-369-90-30."></meta>
      </Helmet>
      <div className="crumbs">
        <Link className="crumbs__link" to="/">
          <img className="crumbs__logo" src={crumbs} alt="crumbs" />
        </Link>
        <Link className="crumbs__link" to="catalogSeed">
          <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
          <span className="crumbs__text">Насіння</span>
        </Link>
        <Link className="crumbs__link" to="cornCard">
          <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
          <span className="crumbs__text">Насіння кукурудзи</span>
        </Link>
        <img className="crumbs__arrow" src={forward_arrow} alt="forward-arrow" />
        <span className="crumbs__text">Гібрид кукурудзи НК Термо (NK Termo)</span>
      </div>
      <div className="itemSeed">
        <div className="itemSeed__title">
          <h1 className="itemSeed__title--styles">Гібрид кукурудзи НК Термо (NK Termo)</h1>
        </div>
        <div className={"item__stock " + (false && "item__stock--new")}>
          <span className="item__stock-arr">
            в наявності
          </span>
          <span className="item__stock-road">
            Уточнюйте наявність
          </span>
        </div>
        <div className="itemSeed__container">
          <div className="itemSeed__left">
            <div className="test-1">
              <div className="itemSeed__image-container">
                <img className="itemSeed__image" src={goodsPage} alt="goodsPage" />
              </div>
              <div className="itemSeed__center">
                <div className="itemSeed__block">
                  <div className="itemCorn__logo">
                    <img className="itemCard__image-logo" src={logo1} alt="logo" />
                  </div>
                  <span className="item__factory-text">
                    Виробник:
                    <span className="item__factory-name"> Syngenta</span>
                  </span>
                </div>
                <div className="characteristic__wrap">
                  <div className="aside__title">Основні характеристики</div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Комерційна назва</div>
                    <div className="characteristic__value">НК Термо (NK Termo)</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Культура</div>
                    <div className="characteristic__value">Кукурудза</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Виробник</div>
                    <div className="characteristic__value">Syngenta</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Призначення</div>
                    <div className="characteristic__value">зерно</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">ФАО</div>
                    <div className="characteristic__value">330</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Тип зерна</div>
                    <div className="characteristic__value">зубоподібний</div>
                  </div>
                  <div className="characteristic__container">
                    <div className="characteristic__label">Спец. технології</div>
                    <div className="characteristic__value">відсутні</div>
                  </div>
                </div>
                <div className="itemSeed__offer">
                  <div className="item__price">
                    <div className="price__charts">
                      <span className="price__item">Роздрібна ціна</span>
                      <div className="price__taxes">
                        <div>i</div>
                        <div class="price__taxes-content fadeInUp">
                          <span>Ціни вказані з ПДВ</span>
                        </div>
                      </div>
                    </div>
                    <div className="price item__capacity-tabs-active">
                      <div className="capacity  active-capacity">від 2 500 грн / п.од</div>
                    </div>
                  </div>
                  <div className="item__order">
                    <Link to="order"><Button /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-cart-promo">
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={verified} alt="verified" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Якість гарантовано!</div>
              <div className="cart-promo__label _text-caption">Санберрі Україна пропонує тільки офіційну продукцію</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={time} alt="time" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Працюємо 24/7</div>
              <div className="cart-promo__label _text-caption">Ми приймаємо ваші замовлення щодня без перерв та вихідних</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={money} alt="money" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Оплата</div>
              <div className="cart-promo__label _text-caption">Пропонуємо готівковий та безготівковий розрахунки за товар</div>
            </div>
          </div>
          <div className="cart-promo__item">
            <div className="cart-promo__ico">
              <img className="card-info_photo" src={deliver} alt="deliver" />
            </div>
            <div className="cart-promo__wrap">
              <div className="cart-promo__head">Доставка</div>
              <div className="cart-promo__label _text-caption">По всій Україні Новою Поштою чи іншими службами доставки</div>
            </div>
          </div>
        </div>
        <div className="seeds-tabs">
          <button
            className={toggleState === 1 ? "seed-tabs active-seed-tabs" : "seed-tabs"}
            onClick={() => toggleTab(1)}
          >
            Опис Товару
          </button>
          <button
            className={toggleState === 2 ? "seed-tabs active-seed-tabs" : "seed-tabs"}
            onClick={() => toggleTab(2)}
          >
            Характеристика
          </button>
        </div>
        <div className="seeds-tabs-active">
          <div
            className={toggleState === 1 ? "seeds-active  active-seeds" : "seeds-active"}>
            <Description />
          </div>

          <div
            className={toggleState === 2 ? "seeds-active  active-seeds" : "seeds-active"}>
            <Reference />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
